import React from 'react';
import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
    Dialog,
} from '@mui/material';

const ModalComponent = ({ open, onClose, header, body, actions }) => {
    return (
        <Dialog fullWidth open={open} onClose={onClose}>
            <DialogTitle id="alert-dialog-title">{header}</DialogTitle>
            <DialogContent>{body}</DialogContent>
            {actions?.length > 0 && (
                <DialogActions>
                    {actions.map((action) => (
                        <Button
                            color={action.color}
                            key={`${action.key || action.label}-action-button`}
                            variant={action.variant}
                            startIcon={action.icon}
                            onClick={action.onClick}
                            disabled={action.disabled}
                        >
                            {action.label}
                        </Button>
                    ))}
                </DialogActions>
            )}
        </Dialog>
    );
};

export default ModalComponent;
